<template>
  <div>
    <component-loader :active="loading" />
    <v-row>
      <v-col>
        <v-card>
          <v-card-title class="p-0">
            <v-row class="no-gutters p-0 m-0">
              <v-col>
                <v-tabs class="d-lg-inline" v-model="tab">
                  <v-tab> Assigned To You </v-tab>
                  <v-tab> Shared To You </v-tab>
                  <v-tab> Assigned By You </v-tab>
                  <v-tab> Shared By You </v-tab>
                  <v-tab> Favorites </v-tab>
                  <v-tab> My Playlists </v-tab>
                </v-tabs>
              </v-col>
              <v-col v-if="showFilter">
                <v-autocomplete
                  dense
                  multiple
                  small-chips
                  class="float-sm-none float-md-right pr-lg-2 pr-lg-2"
                  style="max-width: 200px"
                  :items="filters"
                  v-model="filter"
                  prepend-inner-icon="fas fa-filter"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple>
                      <v-list-item-content>
                        <v-list-item-title>Filter by: </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item }}</span>
                    </v-chip>

                    <span v-if="index > 1" class="grey--text caption">
                      (+{{ filter.length - 1 }} others)
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-tabs-items v-model="tab">
              <v-tab-item key="assigned-to-you">
                <assigned-to-you :type="filter"></assigned-to-you>
              </v-tab-item>
              <v-tab-item key="shared-to-you">
                <shared-to-you :type="filter"></shared-to-you>
              </v-tab-item>
              <v-tab-item key="assigned-by-you">
                <assigned-by-you :type="filter"></assigned-by-you>
              </v-tab-item>
              <v-tab-item key="shared-by-you">
                <shared-by-you :type="filter"></shared-by-you>
              </v-tab-item>
              <v-tab-item key="my-favorites">
                <my-favorites></my-favorites>
              </v-tab-item>
              <v-tab-item key="my-playlists">
                <my-playlists></my-playlists>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <unfinished-contents-dialog></unfinished-contents-dialog>
  </div>
</template>

<script>
import AssignedToYou from '@/components/assigned-and-shared-contents/AssignedToYou';
import SharedToYou from '@/components/assigned-and-shared-contents/SharedToYou';
import MyPlaylists from '@/components/assigned-and-shared-contents/MyPlaylists';
import MyFavorites from '@/components/assigned-and-shared-contents/MyFavorites';
import AssignedByYou from '@/components/assigned-and-shared-contents/AssignedByYou';
import SharedByYou from '@/components/assigned-and-shared-contents/SharedByYou';
import UnfinishedContentsDialog from '@/components/assigned-and-shared-contents/UnfinishedContentsDialog';

export default {
  name: 'AssignedAndSharedContents',
  components: {
    UnfinishedContentsDialog,
    SharedByYou,
    AssignedByYou,
    MyFavorites,
    MyPlaylists,
    SharedToYou,
    AssignedToYou,
  },
  data() {
    return {
      loading: false,
      tab: null,
      filter: [],
      filters: ['Playlist', 'Unit', 'Module'],
    };
  },
  created() {
    this.filter = this.filters;
  },
  computed: {
    showFilter() {
      return true;
    },
  },
  methods: {},
};
</script>

<style scoped></style>
